import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Wrapper } from './styles.js';
const defaultFormatMessage = (message) => message;
export const isErrorVisible = (error, touched = false, withTouched = true, submitError) => {
    const visible = withTouched ? touched : true;
    return Boolean((visible && error) || submitError);
};
const Error = ({ name, formatMessage = defaultFormatMessage, withTouched = true, touched, submitError, error, renderError, }) => {
    const errorVisible = isErrorVisible(error, touched, withTouched, submitError);
    const currentError = error || submitError;
    const formattedError = typeof currentError === 'string' ? formatMessage(currentError) : undefined;
    if (!errorVisible && !renderError) {
        return null;
    }
    return (_jsx("div", { id: `${name}-error`, "data-testid": `${name}-error`, children: _jsx(Wrapper, { children: renderError ? renderError({ errorVisible, error: formattedError }) : errorVisible && formattedError }) }));
};
export default React.memo(Error);
